import type { Template } from "@/types";

export const PO_07_H4_V3: Template[] = [
    {
        id: "po-07-h4v3-01",
        name: "PO 01 - H4V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h4_v3_01.png",
        size: [1190, 850],
        style: {},
        slots: [          
            { id: "1", x: 42, y: 232, width: 254, height: 190, rotation: 0, imageRotation: 0 },
            { id: "2", x: 42, y: 430, width: 254, height: 189, rotation: 0, imageRotation: 0 },
            { id: "3", x: 304, y: 232, width: 254, height: 190, rotation: 0, imageRotation: 0 },
            { id: "4", x: 304, y: 430, width: 254, height: 189, rotation: 0, imageRotation: 0 },
            { id: "5", x: 636, y: 156, width: 341, height: 538, rotation: 0, imageRotation: 0 },
            { id: "6", x: 985, y: 156, width: 166, height: 265, rotation: 0, imageRotation: 0 },
            { id: "7", x: 985, y: 429, width: 166, height: 265, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h4v3-02",
        name: "PO 02 - H4V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h4_v3_02.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 73, y: 173, width: 461, height: 332, rotation: 0, imageRotation: 0 },      
            { id: "2", x: 73, y: 513, width: 227, height: 164, rotation: 0, imageRotation: 0 },
            { id: "3", x: 308, y: 513, width: 227, height: 164, rotation: 0, imageRotation: 0 },
            { id: "4", x: 653, y: 125, width: 482, height: 345, rotation: 0, imageRotation: 0 },
            { id: "5", x: 653, y: 478, width: 156, height: 247, rotation: 0, imageRotation: 0 },
            { id: "6", x: 817, y: 478, width: 156, height: 247, rotation: 0, imageRotation: 0 },
            { id: "7", x: 981, y: 478, width: 155, height: 247, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h4v3-03",
        name: "PO 03 - H4V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h4_v3_03.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 46, y: 247, width: 503, height: 357, rotation: 0, imageRotation: 0 },
            { id: "2", x: 812, y: 247, width: 211, height: 357, rotation: 0, imageRotation: 0 },
            { id: "3", x: 640, y: 247, width: 164, height: 114, rotation: 0, imageRotation: 0 },
            { id: "4", x: 640, y: 369, width: 164, height: 114, rotation: 0, imageRotation: 0 },
            { id: "5", x: 640, y: 491, width: 164, height: 114, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1031, y: 247, width: 114, height: 175, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1031, y: 430, width: 114, height: 174, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h4v3-04",
        name: "PO 04 - H4V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h4_v3_04.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 46, y: 166, width: 493, height: 397, rotation: 0, imageRotation: 0 },          
            { id: "2", x: 46, y: 571, width: 159, height: 111, rotation: 0, imageRotation: 0 },
            { id: "3", x: 213, y: 571, width: 159, height: 111, rotation: 0, imageRotation: 0 },
            { id: "4", x: 380, y: 571, width: 159, height: 111, rotation: 0, imageRotation: 0 },
            { id: "5", x: 628, y: 144, width: 351, height: 562, rotation: 0, imageRotation: 0 },
            { id: "6", x: 986, y: 144, width: 169, height: 277, rotation: 0, imageRotation: 0 },
            { id: "7", x: 986, y: 429, width: 169, height: 277, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h4v3-05",
        name: "PO 05 - H4V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h4_v3_05.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 94, y: 222, width: 407, height: 264, rotation: 0, imageRotation: 0 },           
            { id: "2", x: 94, y: 494, width: 200, height: 134, rotation: 0, imageRotation: 0 },
            { id: "3", x: 302, y: 494, width: 199, height: 134, rotation: 0, imageRotation: 0 },
            { id: "4", x: 700, y: 222, width: 386, height: 201, rotation: 0, imageRotation: 0 },
            { id: "5", x: 700, y: 431, width: 124, height: 197, rotation: 0, imageRotation: 0 },
            { id: "6", x: 832, y: 431, width: 123, height: 197, rotation: 0, imageRotation: 0 },
            { id: "7", x: 963, y: 431, width: 123, height: 197, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h4v3-06",
        name: "PO 06 - H4V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h4_v3_06.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 42, y: 221, width: 516, height: 284, rotation: 0, imageRotation: 0 },
            { id: "2", x: 42, y: 512, width: 167, height: 116, rotation: 0, imageRotation: 0 },
            { id: "3", x: 217, y: 512, width: 167, height: 116, rotation: 0, imageRotation: 0 },
            { id: "4", x: 392, y: 512, width: 166, height: 116, rotation: 0, imageRotation: 0 },
            { id: "5", x: 691, y: 221, width: 255, height: 407, rotation: 0, imageRotation: 0 },
            { id: "6", x: 954, y: 222, width: 124, height: 199, rotation: 0, imageRotation: 0 },
            { id: "7", x: 954, y: 429, width: 124, height: 199, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h4v3-07",
        name: "PO 07 - H4V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h4_v3_07.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 22, y: 221, width: 554, height: 407, rotation: 0, imageRotation: 0 },
            { id: "2", x: 803, y: 221, width: 242, height: 407, rotation: 0, imageRotation: 0 },
            { id: "3", x: 613, y: 221, width: 183, height: 131, rotation: 0, imageRotation: 0 },
            { id: "4", x: 613, y: 360, width: 183, height: 131, rotation: 0, imageRotation: 0 },
            { id: "5", x: 613, y: 499, width: 183, height: 130, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1052, y: 221, width: 115, height: 200, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1052, y: 429, width: 115, height: 199, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h4v3-08",
        name: "PO 08 - H4V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h4_v3_08.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 0, y: 245, width: 232, height: 360, rotation: 0, imageRotation: 0 },
            { id: "2", x: 240, y: 245, width: 232, height: 176, rotation: 0, imageRotation: 0 },
            { id: "3", x: 240, y: 429, width: 232, height: 176, rotation: 0, imageRotation: 0 },
            { id: "4", x: 720, y: 245, width: 231, height: 176, rotation: 0, imageRotation: 0 },
            { id: "5", x: 480, y: 245, width: 232, height: 360, rotation: 0, imageRotation: 0 },
            { id: "6", x: 720, y: 429, width: 231, height: 176, rotation: 0, imageRotation: 0 },
            { id: "7", x: 959, y: 245, width: 231, height: 360, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-07-h4v3-09",
        name: "PO 09 - H4V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h4_v3_09.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 0, y: 238, width: 255, height: 183, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 429, width: 255, height: 183, rotation: 0, imageRotation: 0 },          
            { id: "3", x: 263, y: 238, width: 224, height: 374, rotation: 0, imageRotation: 0 },
            { id: "4", x: 495, y: 238, width: 224, height: 374, rotation: 0, imageRotation: 0 },
            { id: "5", x: 727, y: 238, width: 224, height: 374, rotation: 0, imageRotation: 0 },
            { id: "6", x: 960, y: 238, width: 230, height: 183, rotation: 0, imageRotation: 0 },
            { id: "7", x: 960, y: 429, width: 230, height: 183, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h4v3-10",
        name: "PO 10 - H4V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h4_v3_10.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 94, y: 122, width: 431, height: 299, rotation: 0, imageRotation: 0 },
            { id: "2", x: 94, y: 429, width: 431, height: 298, rotation: 0, imageRotation: 0 },
            { id: "3", x: 533, y: 122, width: 431, height: 299, rotation: 0, imageRotation: 0 },
            { id: "4", x: 533, y: 429, width: 431, height: 298, rotation: 0, imageRotation: 0 },
            { id: "5", x: 972, y: 122, width: 124, height: 197, rotation: 0, imageRotation: 0 },
            { id: "6", x: 972, y: 327, width: 124, height: 196, rotation: 0, imageRotation: 0 },
            { id: "7", x: 972, y: 531, width: 124, height: 196, rotation: 0, imageRotation: 0 }
        ],
    }
];